import * as React from "react";
const SvgDiamond = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 7, y: 2.5, width: 9, height: 9, transform: "rotate(45 8 3.24414)", fill: "currentColor" }));
export default SvgDiamond;
